import type {
  ChallengeDefinition,
  EvidenceLevel,
  PlayerProgress,
} from "./schema";

const evidenceRank: Record<EvidenceLevel, number> = {
  introduced: 0,
  supported: 1,
  independent: 2,
};

export function recordChallengeCompletion(
  progress: PlayerProgress,
  challenge: ChallengeDefinition,
  hintsUsed: number,
  completedAt = new Date().toISOString(),
): PlayerProgress {
  const evidence: EvidenceLevel = hintsUsed > 0 ? "supported" : "independent";
  const completedChallengeIds = progress.completedChallengeIds.includes(
    challenge.id,
  )
    ? [...progress.completedChallengeIds]
    : [...progress.completedChallengeIds, challenge.id];
  const objectiveEvidence = { ...progress.objectiveEvidence };
  const attempts = [...progress.attempts];

  for (const objectiveId of challenge.objectiveIds) {
    const previous = objectiveEvidence[objectiveId];
    objectiveEvidence[objectiveId] = {
      strongestEvidence:
        previous &&
        evidenceRank[previous.strongestEvidence] > evidenceRank[evidence]
          ? previous.strongestEvidence
          : evidence,
      attempts: (previous?.attempts ?? 0) + 1,
      lastAttemptAt: completedAt,
    };
    attempts.push({
      challengeId: challenge.id,
      objectiveId,
      evidence,
      hintsUsed,
      completedAt,
    });
  }

  return {
    ...progress,
    completedChallengeIds,
    objectiveEvidence,
    attempts,
  };
}

export function completedCount(
  progress: PlayerProgress,
  challenges: ChallengeDefinition[],
): number {
  const completed = new Set(progress.completedChallengeIds);
  return challenges.filter(({ id }) => completed.has(id)).length;
}
